import { connect } from 'react-redux';
import SelectFilter from '../../components/Forms/SelectFilter';
import LoadingContainer from '../../components/Structure/Layouts/LoadingContainer';
import TitleContainer from '../../components/Structure/Layouts/TitleContainer';
import ActionTopBar from '../../components/Structure/Table/ActionTopBar';
import { translations as translations_eng } from '../../texts/eng/sponsors-translations'
import SimpleTable from './components/SimpleTable';
import AddSponsorModal from './modals/AddSponsorModal';
import EditSponsorModal from './modals/EditSponsorModal';
import useContactView from './useSponsorsView';


const SponsorsView = ({ language, history, is_auth }) => {

    const content = translations_eng
    const { system, view_data, actions } = useContactView({ language, history, is_auth, content })


    return (
        <LoadingContainer
            loading={system.loading}
            error={system.error}
            onCloseError={actions.onCloseError}
        >
            <TitleContainer title={content.title}>
                <AddSponsorModal
                    open={view_data.add_modal}
                    form={view_data.form}
                    onChange={actions.onChange}
                    onSubmit={actions.onAddSponsor}
                    onClose={actions.onCloseAddModal}
                    content={content.modals.add_modal}
                />
                <EditSponsorModal
                    open={view_data.edit_modal}
                    form={view_data.form}
                    onChange={actions.onChange}
                    onSubmit={actions.onUpdateSponsor}
                    onClose={actions.onCloseEditModal}
                    content={content.modals.edit_modal}
                />
                <ActionTopBar
                    filter={content.filter}
                    filterValue={view_data.filterValue}
                    onChangeFilter={actions.onUpdateFilterValue}
                    search
                    searchData={view_data.form.search}
                    onSearch={actions.onSearchContact}
                    add
                    onAdd={actions.onOpenAddModal}
                    onUpdateSearch={actions.onResetTableFilter}
                />
                <SimpleTable
                    onSelectedItem={actions.onSelectSponsor}
                    data={view_data.sponsors}
                    tableFilter={view_data.tableFilter}
                    onUpdateTableFilter={actions.onUpdateTableFilter}
                    total={view_data.total}
                    loading={system.sending}
                    onRemoveItem={actions.onPreDeleteRegister}
                    noData={content.noData}
                    header={content.header}
                />
            </TitleContainer>
        </LoadingContainer>
    )
}

const mapStateToProps = (state) => {
    return {
        language: state.language,
        is_auth: state.is_auth
    }
}

export default connect(mapStateToProps)(SponsorsView) 